import React, { Fragment, useState, useEffect } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { setOverviewTab, getInGameItemSalesByItem } from "actions";
import * as C from "components";
import * as H from "helper";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: "#fafafa",
    },
  })
);

const InGameItemByItem = ({
  setOverviewTab,
  getInGameItemSalesByItem,
  game,
  loading,
  overviewData,
}) => {
  useEffect(() => {
    setOverviewTab("item");
    const game = window.location.pathname.split("/");
    getInGameItemSalesByItem(game[2]);
  }, [window.location.pathname]);

  // useEffect(() => {
  //   setOverviewTab("item");
  //   const game = window.location.pathname.split("/");
  //   getInGameItemSalesByItem(game);
  // }, [game, overviewData]);

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid item sm={12} lg={6}>
          <C.Top10AmountByItem
            title="アイテム別FIAT課金取引額"
            source="ingame-fiat"
            loading={loading.ovByItem}
            total={overviewData.fiatAmount}
            game={game}
          />
        </Grid>
        <Grid item sm={12} lg={6}>
          <C.Top10TxCountByItem
            title="アイテム別FIAT課金取引件数"
            source="ingame-fiat"
            loading={loading.ovByItem}
            total={overviewData.fiatCount}
            game={game}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item sm={12} lg={6}>
          <C.Top10AmountByItem
            title="アイテム別DEP課金取引額"
            source="ingame-dep"
            loading={loading.ovByItem}
            total={overviewData.depAmount}
            game={game}
          />
        </Grid>
        <Grid item sm={12} lg={6}>
          <C.Top10TxCountByItem
            title="アイテム別DEP課金取引件数"
            source="ingame-dep"
            loading={loading.ovByItem}
            total={overviewData.depCount}
            game={game}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

InGameItemByItem.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  dateRange: state.page.dateRange,
  dateLoaded: state.data.dataLoaded,
  loading: state.inGameItemSales.loading,
  overviewData: state.inGameItemSales.dataOverview
});

const mapDispatchToProps = (dispatch) => ({
  setOverviewTab: (param) => dispatch(setOverviewTab(param)),
  getInGameItemSalesByItem: (param) =>
    dispatch(getInGameItemSalesByItem(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(InGameItemByItem));
